import styled from "styled-components";

export const AttachmentSection = styled.div<{ isDragActive: boolean }>`
  opacity: ${({ isDragActive }) => (isDragActive ? 0.2 : 1)};
`;

export const AttachmentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AttachmentButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  width: 44px;
  height: 44px;
`;

export const AttachmentWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #ddd;
  cursor: pointer;
  overflow: hidden;
`;

export const AttachmentImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

export const AttachmentText = styled.span`
  text-align: center;
  font-size: 20px;
  line-height: 1;
`;

export const AttachmentCloseIcon = styled.button`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: white;
  font-size: 10px;
  line-height: 1;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;
